import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Objects, Collections} from "components";

import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Access from "constants/Access";

const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'Events',
		url: '/events',
		icon: 'calendar',
	}
];

export default class Event extends Framework.Components.View {

	constructor(props) {
		super(props, 'details');
	}

	render() {
		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name: this.state.name,
				url: `/events/${this.props.id}`,
				icon: 'clock-o',
			}
		]);

		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={this.props.history}/>

				<Tabs value={this.state.tab} onChange={this.handleTabChange} component={'div'}>
					<Tab label="Event" value="details"/>
					{this.props.userAccess < Access.Supervisor &&<Tab label="Change Log" value="logs"/>}
				</Tabs>

				<div style={{display: this.state.tab === 'details' ? 'block' : 'none'}}>
					<Objects.Event

						id={this.props.match.params.id}
						history={this.props.history}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						updateName={this.updateName}
						baseUrl={this.props.baseUrl}
					/>
				</div>
				{this.state.tab === 'logs' && this.props.userAccess < Access.Supervisor  &&
				<Collections.LogsEvents
					parent={this.props.match.params.id}
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
				/>}
			</div>
		)
	}
};